<template>
  <div class="investment" v-if="item">
    <InternalHeader
      :item="item"
      :isLoading="isLoading"
      :backgroundImage="backgroundImage"
      :backButton="backButton"
      :entity="entity">
    </InternalHeader>
    <router-view :item="item"/>
  </div>
</template>

<script>
import { investmentAdvisoryApi } from '@/api';
import { mapGetters } from 'vuex';
import InternalHeader from '@/components/InternalHeader.vue';

export default {
  name: 'Investment',
  props: ['id'],
  data() {
    return {
      item: this.$route.params.item || null,
      isLoading: false,
      backButton: {
        name: 'InvestmentAdvisoryList',
      },
      entity: 'investmentAdvisory',
    };
  },
  components: {
    InternalHeader,
  },
  async created() {
    if (!this.item) {
      this.getRemoteItem();
    }
  },
  computed: {
    ...mapGetters('options', ['currentOptions']),
    backgroundImage() {
      return this.item.acf.header_bg_investment || this.currentOptions.header_bg_investment;
    },
  },
  methods: {
    async getRemoteItem() {
      try {
        this.isLoading = true;
        const response = await investmentAdvisoryApi.getInvestmentAdvisorySingle(this.id);
        this.isLoading = false;
        this.item = response.data;
      } catch (error) {
        this.isLoading = false;
        if (error && error.response) {
          this.$notify({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: error.response.data.message,
          });
        }
        throw error;
      }
    },
  },
};
</script>
